import React, { useState } from 'react';
import { IoMdRefresh } from 'react-icons/io';

import { useGetConfQuery } from '../../services/RttBridgeApi';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

import Spinner from '../UI/Spinner'
import "./AvailableConferences.css"
import ConfDetail from './ConfDetail';



export const AvailableConferences = () => {
    const bridgeUrl = useSelector((state: RootState) => state.bridgeUrl.bUrl)
    const [selectedConf, setSelectedConf] = useState<string>('');
    const [confId, setConfId] = useState<string>('');
    const [confName, setConfName] = useState<string>('');
    const [participantCounts, setParticipantCounts] = useState<Record<string, number>>({});


    const { data: confData, isLoading, isError, isSuccess, refetch } = useGetConfQuery(bridgeUrl)


    let loadedConferences: [] = []
    let count: number = 0;

    if (confData !== undefined && confData !== null) {
        loadedConferences = confData.conferences
        count = confData.count
    }


    const conferencesList = loadedConferences.map((conference: any) => (
        <li key={conference.id}
            onClick={() => {
                setSelectedConf(conference)
                setConfId(conference.id)
                setConfName(conference.name)
            }}
            className='conference-list-item'>
            {conference.name ?
                <h4 className='conf-name'>{conference.name} ({participantCounts[conference.id] || 0} participants)</h4> :
                <h4 className='conf-name'>{conference.id} ({participantCounts[conference.id] || 0} participants)</h4>}
            <small>
                <p className='conf-id'>{conference.id} </p>
            </small>
        </li >
    ));

    const updateSelectedConf = () => {
        setSelectedConf('');
    };

    if (isLoading) {
        return (
            <div className='empty-conf' >
                <Spinner />
            </div >
        );
    }
    if (isError) {
        return (
            <div className='empty-conf'>
                <p>An error has occurred!</p>
            </div >
        );
    }
    if (!confData) {
        return (
            <div className='empty-conf' >
                <p>No Conference :(</p>
            </div >
        );
    }
    return (

        <div className='conf-list-info'>
            <div className='confs'>
                <div className='title' >
                    <h3 >
                        Conferences List <span>( {count} )</span>
                    </h3>
                    <button className='refresh-button round-button' onClick={() => refetch()}><IoMdRefresh className='icon' /></button>
                </div>
                <div className='conferences-list'>
                    {isSuccess && !isError ? 
                    <ul>{conferencesList}</ul> :
                     <p>No Conference Found.</p>}
                </div>
            </div>

            <div className='info'>
                {selectedConf ?
                    <ConfDetail
                        conferenceId={confId}
                        conference={selectedConf}
                        conferenceName={confName}
                        updateSelectedConf={updateSelectedConf}
                        setParticipantCountInParent={(count: number) =>
                            setParticipantCounts(prevCounts => ({ ...prevCounts, [confId]: count }))
                        }
                    />
                    :
                    <div className='choose-conf'>
                        <h3 className='no-conf'>We would appreciate it if you could pick one conference from the list.
                        </h3>
                    </div>
                }
            </div>

        </div >
    )
}